export default {
  data() {
    return {
      clientsOptions: [],
      projectsOptions: [],
      fieldsetsOptions: [],
      templatesOptions: [],
      contactsOptions: [],
      usersOptions: [],
      statusOptions: [],
      tagsOptions: [],
      localesOptions: [],
      themesOptions: [],
      timeColumnsOptions: [
        { label: this.$t("filters.created_at"), value: "created_at" },
        { label: this.$t("filters.updated_at"), value: "updated_at" },
        { label: this.$t("filters.last_active_at"), value: "last_active_at" },
      ],
      relativeTimeOptions: [
        { label: this.$t("filters.timeRelative.today"), value: "today" },
        {
          label: this.$t("filters.timeRelative.yesterday"),
          value: "yesterday",
        },
        {
          label: this.$t("filters.timeRelative.last_week"),
          value: "last_week",
        },
        {
          label: this.$t("filters.timeRelative.last_month"),
          value: "last_month",
        },
        {
          label: this.$t("filters.timeRelative.last_year"),
          value: "last_year",
        },
        { label: this.$t("filters.timeRelative.custom"), value: "custom" },
      ],
      customFieldOptions: {},
      hasCesDailyAboveOptions: [
        {
          label: "25",
          value: 25,
        },
        {
          label: "50",
          value: 50,
        },
        {
          label: "75",
          value: 75,
        },
      ],
    };
  },
  methods: {
    setDropdownOptions() {
      if (this.templates) {
        this.templates.forEach((template) => {
          this.templatesOptions.push({
            label: template.name,
            value: template.uid,
          });
        });
      }
      if (this.contacts) {
        this.contacts.forEach((contact) => {
          const name = this.$h.formatName(contact);
          this.contactsOptions.push({ label: name, value: contact.uid });
        });
      }
      if (this.clients) {
        this.clients.forEach((client) => {
          const name = this.$h.formatName(client);
          this.clientsOptions.push({ label: name, value: client.uid });
        });
      }
      if (this.projects) {
        this.projects.forEach((project) => {
          this.projectsOptions.push({
            label: project.title,
            value: project.uid,
          });
        });
      }
      if (this.fieldsets) {
        this.fieldsets.forEach((fieldset) => {
          this.fieldsetsOptions.push({
            label: fieldset.name,
            value: fieldset.uid,
          });
        });
      }
      if (this.users) {
        this.users.forEach((user) => {
          const name = this.$h.formatName(user);
          this.usersOptions.push({ label: name, value: user.uid });
        });
      }
      if (this.projectsStati) {
        Object.keys(this.projectsStati).forEach((key) => {
          if (this.projectsStati[key].bit > 4) {
            const title = this.projectsStati[key].title[this.teams[this.$route.params.team].account.locale]
              ? this.projectsStati[key].title[this.teams[this.$route.params.team].account.locale]
              : this.projectsStati[key].title.default;
            this.statusOptions.push({ label: title, value: key });
          }
        });
      }
      if (this.teamTags) {
        this.teamTags.forEach((tag) => {
          this.tagsOptions.push({ label: tag.name, value: tag.name });
        });
      }
      if (this.teamLanguages) {
        this.teamLanguages.forEach((lang) => {
          this.localesOptions.push({
            label: this.$t('lang["' + lang + '"]'),
            value: lang,
          });
        });
      }
      if (this.teamThemes) {
        this.teamThemes.forEach((theme) => {
          this.themesOptions.push({ label: theme.name, value: theme.uid });
        });
      }
      if (this.projectsCustomFields) {
        Object.keys(this.projectsCustomFields).forEach((key) => {
          if (this.projectsCustomFields[key].filterable) {
            let label;
            let options = [];
            this.projectsCustomFields[key].config.options.forEach((option) => {
              option.label[this.teams[this.$route.params.team].account.locale]
                ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                : (label = option.label.default);
              options.push({ label: label, value: option.value });
            });
            this.customFieldOptions[key] = options;
          }
        });
      }
      this.filterDropdown[0].options.forEach((option) => {
        if (option.select) {
          if (option.select.name === "client") {
            option.select.options = this.clientsOptions;
          }
          if (option.select.name === "project") {
            option.select.options = this.projectsOptions;
          }
          if (option.select.name === "fieldset") {
            option.select.options = this.fieldsetsOptions;
          }
          if (option.select.name === "with_template" || option.select.name === "without_template") {
            option.select.options = this.templatesOptions;
          }
          if (option.select.name === "with_contact" || option.select.name === "without_contact") {
            option.select.options = this.contactsOptions;
          }
          if (option.select.name === "with_user" || option.select.name === "without_user") {
            option.select.options = this.usersOptions;
          }
          if (option.select.name === "with_status" || option.select.name === "without_status") {
            option.select.options = this.statusOptions;
          }
          if (option.select.name === "with_tag" || option.select.name === "without_tag") {
            option.select.options = this.tagsOptions;
          }
          if (option.select.name === "with_locale" || option.select.name === "without_locale") {
            option.select.options = this.localesOptions;
          }
          if (option.select.name === "with_theme" || option.select.name === "without_theme") {
            option.select.options = this.themesOptions;
          }
          if (option.select.name === "time_col") {
            option.select.options = this.timeColumnsOptions;
          }
          if (option.select.name === "time_relative") {
            option.select.options = this.relativeTimeOptions;
          }
          if (option.select.name === "with_type") {
            option.select.options = this.templateSnippetsTypeOptions;
          }
          if (option.select.name === "has_ces_daily_above") {
            option.select.options = this.hasCesDailyAboveOptions;
          }
          if (this.projectsCustomFields) {
            Object.keys(this.projectsCustomFields).forEach((key) => {
              if (this.projectsCustomFields[key].filterable) {
                if (option.select.name === "with_custom_" + key || option.select.name === "without_custom_" + key) {
                  option.select.options = this.customFieldOptions[key];
                }
              }
            });
          }
        }
      });
    },
    search(list, apiCall) {
      apiCall(
        {
          search: this.searchQuery,
          page: 1,
          per_page: this.teamsSettings[this.$route.params.team].listsSettings[list].pagination.perPage,
          order_col: this.teamsSettings[this.$route.params.team].listsSettings[list].order.col,
          order_dir: this.teamsSettings[this.$route.params.team].listsSettings[list].order.dir,
        },
        true
      );
      this.$store.commit("GLOBAL_INIT_SEARCH_VALUE", this.searchQuery);
    },
    initSort(list, multiple = false) {
      if (multiple) {
        this.mobileDropdown = this[list].mobileDropdown;
        this.sortMainColDropdown = this[list].sortMainColDropdown;
        this.showAsFirstColDropdown = this[list].showAsFirstColDropdown;
        this.showAsSecondColDropdown = this[list].showAsSecondColDropdown;
        this.showAsThirdColDropdown = this[list].showAsThirdColDropdown;
      }
      if (this.mobileDropdown) {
        if (this.mobileDropdown[0]) {
          this.mobileDropdown[0].options.forEach((option) => {
            option.active = option.key === this.teamsSettings[this.$route.params.team].listsSettings[list].order.dir;
          });
        }
        if (this.mobileDropdown[1]) {
          this.mobileDropdown[1].options.forEach((option) => {
            option.active = option.key === this.teamsSettings[this.$route.params.team].listsSettings[list].order.col;
          });
        }
      }
      if (this.sortMainColDropdown) {
        this.sortMainColDropdown[0].options.forEach((option) => {
          option.active =
            this.sortMainColDropdown[0].key ===
              this.teamsSettings[this.$route.params.team].listsSettings[list].order.col &&
            option.key === this.teamsSettings[this.$route.params.team].listsSettings[list].order.dir;
        });
      }
      if (this.teamsSettings[this.$route.params.team].listsSettings[list].showAs) {
        if (this.showAsFirstColDropdown) {
          this.showAsFirstColDropdown[0].disabled =
            !this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.firstCol.sortable;
          this.showAsFirstColDropdown[0].options.forEach((option) => {
            option.disabled = !this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.firstCol.sortable;
            option.active =
              this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.firstCol.key ===
                this.teamsSettings[this.$route.params.team].listsSettings[list].order.col &&
              option.key === this.teamsSettings[this.$route.params.team].listsSettings[list].order.dir;
          });
        }
        if (this.showAsSecondColDropdown) {
          this.showAsSecondColDropdown[0].disabled =
            !this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.secondCol.sortable;
          this.showAsSecondColDropdown[0].options.forEach((option) => {
            option.disabled =
              !this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.secondCol.sortable;
            option.active =
              this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.secondCol.key ===
                this.teamsSettings[this.$route.params.team].listsSettings[list].order.col &&
              option.key === this.teamsSettings[this.$route.params.team].listsSettings[list].order.dir;
          });
        }
        if (this.showAsThirdColDropdown) {
          this.showAsThirdColDropdown[0].disabled =
            !this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.thirdCol.sortable;
          this.showAsThirdColDropdown[0].options.forEach((option) => {
            option.disabled = !this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.thirdCol.sortable;
            option.active =
              this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.thirdCol.key ===
                this.teamsSettings[this.$route.params.team].listsSettings[list].order.col &&
              option.key === this.teamsSettings[this.$route.params.team].listsSettings[list].order.dir;
          });
        }
      }
    },
    initShowAs(list) {
      if (this.showAsFirstColDropdown && this.showAsFirstColDropdown[1]) {
        this.showAsFirstColDropdown[1].options.forEach((option) => {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.firstCol.key === option.key) {
            option.active = true;
          }
        });
      }
      if (this.showAsSecondColDropdown && this.showAsSecondColDropdown[1]) {
        this.showAsSecondColDropdown[1].options.forEach((option) => {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.secondCol.key === option.key) {
            option.active = true;
          }
        });
      }
      if (this.showAsThirdColDropdown && this.showAsThirdColDropdown[1]) {
        this.showAsThirdColDropdown[1].options.forEach((option) => {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].showAs.thirdCol.key === option.key) {
            option.active = true;
          }
        });
      }
    },
    changeCol(data) {
      this.setListsSettings(data).then(() => {
        this.initSort(data.list);
      });
    },
    initFilters(list) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.switch && option.switch.name && !option.select) {
          option.active =
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.switch.name].active;
          option.switch.model =
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.switch.name].model;
        }
        if (option.select && !option.select.custom) {
          option.active =
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.select.name].active;
          if (option.filterGroup)
            this.filterDropdown[0].groups[option.filterGroup].active =
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.select.name].active;
          option.select.model = this.transformRequestToModelObject(
            this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.select.name].model,
            option.select.name
          );
          if (
            !this.transformRequestToModelObject(
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.select.name].model,
              option.select.name
            ) &&
            option.select.preselectModel
          )
            option.select.model = option.select.preselectModel;
        }
        if (option.select && option.select.custom) {
          this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters.forEach((obj, key) => {
            if (obj.name === option.select.name) {
              option.active = this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].active;
              option.select.model = this.transformRequestToModelObject(
                this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].model,
                option.select.name,
                key
              );
            }
          });
        }
        if (option.dateTimeRange) {
          let model = [];
          option.dateTimeRange.name.forEach((field) => {
            let thisDate = this.teamsSettings[this.$route.params.team].listsSettings[list].filter[field].model
              ? new Date(this.teamsSettings[this.$route.params.team].listsSettings[list].filter[field].model)
              : "";
            model.push(thisDate);
          });
          option.dateTimeRange.model = model;
        }
      });
    },
    setFilterRequestObjectFromStore(list, params) {
      this.filterDropdown[0].options.forEach((option) => {
        if (option.switch && option.switch.name && !option.select) {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.switch.name].active) {
            params[option.switch.name] =
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.switch.name].model;
          }
        }
        if (option.select && !option.select.custom) {
          if (this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.select.name].active) {
            params[option.select.name] =
              this.teamsSettings[this.$route.params.team].listsSettings[list].filter[option.select.name].model;
          }
        }
        if (option.select && option.select.custom) {
          this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters.forEach((obj, key) => {
            if (obj.name === option.select.name) {
              if (this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].active) {
                if (!params[option.select.name.split("_").slice(0, 2).join("_")])
                  params[option.select.name.split("_").slice(0, 2).join("_")] = [];
                this.teamsSettings[this.$route.params.team].listsSettings[list].customFilters[key].model.forEach(
                  (val) => {
                    params[option.select.name.split("_").slice(0, 2).join("_")].push(
                      option.select.name.split("_").slice(2).join("_") + "." + val
                    );
                  }
                );
              }
            }
          });
        }
        if (option.dateTimeRange) {
          option.dateTimeRange.name.forEach((field) => {
            params[field] = this.teamsSettings[this.$route.params.team].listsSettings[list].filter[field].model;
          });
        }
      });
      return params;
    },
    resetFilters(apiCall, list = null) {
      this.filterDropdown[0].options.forEach((option) => {
        option.active = false;
        if (option.switch && option.switch.name) option.switch.model = true;
        if (option.select) option.select.model = [];
        if (option.select && option.select.preselectModel) option.select.model = option.select.preselectModel;
        if (option.dateTimeRange) option.dateTimeRange.model = [];
      });
      if (this.filterDropdown[0].groups) {
        Object.keys(this.filterDropdown[0].groups).forEach((key) => {
          this.filterDropdown[0].groups[key].active = false;
        });
      }
      apiCall();
      if (list) {
        this.setCurrentFilterPresetHasChanged({ list, state: false });
        this.setCurrentFilterPreset({ list, filterPreset: null });
      }
    },
    transformModelToRequestArray(model, customFieldName = false) {
      if (model.value) {
        return model.value;
      } else {
        let res = [];
        model.forEach((value) => {
          if (typeof value === "object" && value !== null) {
            if (customFieldName) {
              res.push(customFieldName + "." + value.value);
            } else {
              res.push(value.value);
            }
          } else {
            res.push(value);
          }
        });
        return res;
      }
    },
    transformRequestToModelObject(values, select) {
      let res = [];
      if (select === "client") {
        this.clients.forEach((client) => {
          if (client.uid === values) {
            res.push({
              label: client.first_name + " " + client.last_name,
              value: client.uid,
            });
          }
        });
      }
      if (select === "project") {
        this.projects.forEach((project) => {
          if (project.uid === values) {
            res.push({
              label: project.title,
              value: project.uid,
            });
          }
        });
      }
      if (select === "fieldset") {
        console.log("VALUES", values);
        this.fieldsets.forEach((fieldset) => {
          if (fieldset.uid === values) {
            res.push({
              label: fieldset.name,
              value: fieldset.uid,
            });
          }
        });
      }
      if (select === "with_template" || select === "without_template") {
        values.forEach((value) => {
          this.templates.forEach((template) => {
            if (template.uid === value) {
              res.push({ label: template.name, value: template.uid });
            }
          });
        });
      }
      if (select === "with_user" || select === "without_user") {
        values.forEach((value) => {
          this.users.forEach((user) => {
            if (user.uid === value) {
              res.push({
                label: user.first_name + " " + user.last_name,
                value: user.uid,
              });
            }
          });
        });
      }
      if (select === "with_contact" || select === "without_contact") {
        values.forEach((value) => {
          this.contacts.forEach((contact) => {
            if (contact.uid === value) {
              res.push({
                label: contact.first_name + " " + contact.last_name,
                value: contact.uid,
              });
            }
          });
        });
      }
      if (select === "with_status" || select === "without_status") {
        values.forEach((value) => {
          let title = "";
          switch (value) {
            case "ARCHIVED":
              title = this.$t("stati.status.title");
              break;
            case "POSTED":
              title = this.$t("stati.sent.title");
              break;
            case "VISITED":
              title = this.$t("stati.views.title");
              break;
            case "UPLOADS":
              title = this.$t("stati.uploads.title");
              break;
            case "DOWNLOADS":
              title = this.$t("stati.downloads.title");
              break;
            default:
              title = this.projectsStati[value].title[this.teams[this.$route.params.team].account.locale]
                ? this.projectsStati[value].title[this.teams[this.$route.params.team].account.locale]
                : this.projectsStati[value].title.default;
          }
          res.push({ label: title, value: value });
        });
      }
      if (select === "with_tag" || select === "without_tag") {
        values.forEach((value) => {
          this.teamTags.forEach((tag) => {
            if (tag.name === value) {
              res.push({ label: tag.name, value: tag.name });
            }
          });
        });
      }
      if (select === "with_locale" || select === "without_locale") {
        values.forEach((value) => {
          this.teamLanguages.forEach((lang) => {
            if (lang === value) {
              res.push({ label: this.$t('lang["' + lang + '"]'), value: lang });
            }
          });
        });
      }
      if (select === "time_col") {
        return values.length > 0 ? { label: this.$t("filters." + values), value: values } : null;
      }
      if (select === "time_relative") {
        return values.length > 0 ? { label: this.$t("filters.timeRelative." + values), value: values } : null;
      }
      if (
        select.split("_").slice(0, 2).join("_") === "with_custom" ||
        select.split("_").slice(0, 2).join("_") === "without_custom"
      ) {
        values.forEach((value) => {
          if (this.projectsCustomFields) {
            Object.keys(this.projectsCustomFields).forEach((key) => {
              if (this.projectsCustomFields[key].filterable && key === select.split("_").slice(2).join("_")) {
                let label;
                this.projectsCustomFields[key].config.options.forEach((option) => {
                  option.label[this.teams[this.$route.params.team].account.locale]
                    ? (label = option.label[this.teams[this.$route.params.team].account.locale])
                    : (label = option.label.default);
                  if (option.value === parseInt(value)) {
                    res.push({ label, value });
                  }
                });
              }
            });
          }
        });
      }
      return res;
    },
  },
};
